import React from 'react';
import _orderBy from 'lodash/orderBy';

import { IconBroadcast } from '@trqk/components';
import { locale, removeNulls } from '@trqk/utils';

import { DataCard, DataCardTable } from '../components';
import { DetectionSummaryRow } from '.';
import { tooltipShim } from '../../../constants';

interface DetectionSummaryCardProps {
    data: Maybe<Maybe<InsightDetectionSummaryData>[]>;
}

const earningsColor = 'quarternary';

export const DetectionSummaryCard = ({
    data,
}: DetectionSummaryCardProps): JSX.Element => {
    const sortedAndSlicedData = _orderBy(
        removeNulls<InsightDetectionSummaryData>(data),
        ['detection_count'],
        ['desc'],
    ).slice(0, 5);

    return (
        <DataCard
            title={locale.enUS.INSIGHTS.CARDS.DETECTION_SUMMARY.TITLE}
            color={earningsColor}
            header={
                <div className="mx-10">
                    {locale.enUS.INSIGHTS.CARDS.DETECTION_SUMMARY.HEADER.PART_1}{' '}
                    <span className="font-semibold">
                        {
                            locale.enUS.INSIGHTS.CARDS.DETECTION_SUMMARY.HEADER
                                .PART_2
                        }
                    </span>
                </div>
            }
            Icon={IconBroadcast}
            inInsightsIndex={false}
        >
            {sortedAndSlicedData.length === 0 && (
                <div className="mx-16 mt-20 italic text-tertiary-400 text-center text-sm">
                    {locale.enUS.INSIGHTS.CARDS.DETECTION_SUMMARY.EMPTY_MESSAGE}
                </div>
            )}
            {/*
                This keeps spacing consistent between cards that use a tooltip in the header and
                those that don't
            */}
            <div style={{ height: tooltipShim }} />
            <DataCardTable>
                {sortedAndSlicedData.map(
                    (
                        summaryData: InsightDetectionSummaryData,
                        index: number,
                    ): JSX.Element => {
                        const { song_id, channel } = summaryData;
                        const key = `${song_id}.${channel}`;

                        return (
                            <DetectionSummaryRow
                                index={index}
                                key={key}
                                summaryData={summaryData}
                            />
                        );
                    },
                )}
            </DataCardTable>
        </DataCard>
    );
};
